import React from 'react'
import Forgot from './Forgot'

export default function () {
  return (
    <Forgot/>
  )
}
